// extracted by mini-css-extract-plugin
export default {"higherPointsList":"styles_higherPointsList__37wci","lowerAlphaList":"styles_lowerAlphaList__4ASHy"};